import debounce from 'debounce'
import { useSearchParams } from 'react-router-dom'

export const useParams = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const getParams = () => Object.fromEntries([...searchParams])

  const setParam = (name: string, value: string) =>
    setSearchParams({
      ...getParams(),
      [name]: value,
    })

  const setDebounceParam = debounce(setParam, 300)

  return {
    params: getParams(),
    clearParams: () => setSearchParams({}),
    setParam,
    setDebounceParam,
  }
}
